import { apiGet, apiPatch } from './client';

export function getMyNotifications({ unreadOnly = false, limit = 20, offset = 0 } = {}) {
  return apiGet(
    `/me/notifications?unread_only=${unreadOnly ? 'true' : 'false'}&limit=${limit}&offset=${offset}`
  );
}

export function getMyUnreadNotificationsCount() {
  return apiGet('/me/notifications/unread-count');
}

export function markNotificationAsRead(notificationId) {
  return apiPatch(`/me/notifications/${notificationId}/read`, {});
}

export function markAllNotificationsAsRead() {
  return apiPatch('/me/notifications/read-all', {});
}
